import { getID } from "src/libs/utilities";
import { ALIGN, LANDING_TYPE_CONTENT } from "../interfaces";

export default function twirlText () : any[] {
    return [
        {
            id: getID("twirl-text"),
            type: LANDING_TYPE_CONTENT.TWIRL_TEXT,  
            horizontal_align: ALIGN.MIDDLE, 
            "position": { "width": 450 },
            "text": "Дама сдавала багаж: ",
            "delay": 2500,
            "style": {
                "fontSize": 30,
                "textAl": "center"
            },
            "twirl_text": [
                "диван",
                "чемодан",
                "саквояж",
                "картинку",
                "корзинку",
                "картонку и",
                "маленькую собачонку."
            ],
            "twirl_text_color": ["#1656a0", "#f80170", "#a2f801"],
            defaultTitle: "Пословное перечисление"
        },
        {
            id: getID("twirl-text"),
            type: LANDING_TYPE_CONTENT.TWIRL_TEXT,  
            horizontal_align: ALIGN.MIDDLE, 
            "position": { "width": 450 },
            "text": "Пицца -- это ",
            "delay": 4000,
            twirl_tail_delay: .033,
            "style": {
                "fontSize": 30,
                "textAl": "center"
            },
            "twirl_text": [
                "вкусно",
                "полезно",
                "весело",
                "встреча с друзяками",
                "питательно",
                "спортивно",
                "молодёжно"
            ],
            "twirl_text_color": ["#0099ff", "#ff0000"],
            defaultTitle: "Плавный побуквенный наплыв"
        },
    ]
}